import React from 'react';

import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        showDataTitle: '3 000',
        showDataSubtitle: 'человек за сутки проведения форума посетили сайт',
    },
    {
        showDataTitle: '1 500',
        showDataSubtitle: 'участников',
    },
    {
        showDataTitle: '100',
        showDataSubtitle: 'спикеров и экспертов',
    },
    {
        showDataTitle: '12',
        showDataSubtitle: 'инновационных регионов',
    },
    {
        showDataTitle: '40',
        showDataSubtitle: 'деловых мероприятий',
    },
];
const Results = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="tech-leaders-results" smallPaddings={true}>
                <CommonTitle>Результаты</CommonTitle>
                <CommonUsualText className="tech-leaders-results__subtitle">
                    В&nbsp;итоге мы&nbsp;развернули целую экосистему, которая поможет РВК
                    реализовать свою миссию по&nbsp;формированию зрелого венчурного рынка
                    и&nbsp;содействию по&nbsp;достижению Россией технологического лидерства
                    в&nbsp;приоритетных сферах.
                </CommonUsualText>
                <div className="tech-leaders-results-ciphers">
                    <div className="tech-leaders-results-ciphers__wrapper">
                        <div className="tech-leaders-results-ciphers__grid">
                            {list.map(({ showDataTitle, showDataSubtitle }, index) => (
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={0}
                                    delay={100}
                                    animateOnce={true}
                                    duration={1}
                                    className="tech-leaders-results-ciphers__item"
                                    key={index}
                                >
                                    <div className="tech-leaders-results-ciphers__item-wrap">
                                        <div className="tech-leaders-results-ciphers__name">
                                            {showDataTitle}
                                        </div>
                                        <CommonSmallText className="tech-leaders-results-ciphers__desc">
                                            {showDataSubtitle}
                                        </CommonSmallText>
                                    </div>
                                </ScrollAnimation>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
